import * as TK from 'components/post/PostingPreference/translations/constants';
import { Translations } from 'translations/types';

export const postingPreferenceEnUsLocale: Translations = {
  [TK.POSTING_PREFERENCE_ENABLED_OPTION_LABEL]: 'Yes',
  [TK.POSTING_PREFERENCE_DISABLED_OPTION_LABEL]: 'No',
};
